import { Box } from "@mui/material"
import { useCallback } from "react";
import FirebaseTitledCardsWithCTAButtonSection from "../Components/FirebaseTitledCardsWithCTAButtonSection"
import { CATEGORIES_COLLECTION } from "../constants/collectionPaths"
import { useMicrospecThemeLanguageContext } from "../../MicrospecDynamicUI/Themes";

const CategoriesPage: React.FC = () => {
    const { localizationProvider } = useMicrospecThemeLanguageContext();

    const mapDocToCard = useCallback((doc: any) => ({
        id: doc.id,
        image: doc.image,
        icon: doc.icon,
        title: localizationProvider.translate(doc.name) ?? '',
        href: `/category/${doc.id}/products`,
    }), [localizationProvider]);

    return (
        <Box>
            <FirebaseTitledCardsWithCTAButtonSection spec={{
                collectionPath: CATEGORIES_COLLECTION,
                mapDocToCard,
                id: 'categories',
                sectionTitle: {
                    localizationObject: {
                        type: 'Literal',
                        text: 'קטגוריות מוצרים'
                    }
                },
                orderField: 'order',
                orderDirection: 'asc',
            }} />
        </Box>
    );
};

export default CategoriesPage;